import { Grid } from "@mui/material";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";
import AddForm from "@src/domain/devices/add/Form";

export const AddCamera = () => {
    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <AddForm />
                </Grid>
            </Grid>
        </>
    );
};
